/**
 * Sliders JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Sliders
 */
export default class Sliders {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.slider = $( '.slider' );
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Initialize slick sliders.
     */
    initSlickSliders() {

        // Caption slider.
        $( '.caption-slider' ).each( ( i, el ) => {

          const $captionSlider = $( el );
          const $wrapper       = $captionSlider.closest( '.caption-slider-wrapper' );

          $captionSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            dots: true,
            infinite: true,
            arrows: true,
            prevArrow: $wrapper.find( '.previous-slide-caption' ),
            nextArrow: $wrapper.find( '.next-slide-caption' ),
            fade: true,
            speed: 400,
            autoplaySpeed: 4000,
            accessibility: false, // Do not change slide using key navigation.
            lazyLoad: 'ondemand',
            cssEase: 'linear'
          });
        });

        // Hero slider.
        $( '.hero-slider' ).each( ( i, el ) => {

          const $heroSlider = $( el );
          const $wrapper    = $heroSlider.closest( '.hero-slider-wrapper' );

          $heroSlider.slick({
            autoplay: true,
            dots: true,
            infinite: true,
            arrows: true,
            prevArrow: $wrapper.find( '.previous-slide-hero' ),
            nextArrow: $wrapper.find( '.next-slide-hero' ),
            speed: 400,
            accessibility: false, // Do not change slide using key navigation.
            fade: true,
            autoplaySpeed: 4000,
            cssEase: 'linear'
          });
        });

        // Models slider.
        $( '.models-slider' ).slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: false,
            dots: true,
            infinite: true,
            arrows: true,
            prevArrow: $( '.previous-slide-models' ),
            nextArrow: $( '.next-slide-models' ),
            speed: 400,
            accessibility: false, // Do not change slide using key navigation.
            cssEase: 'linear',
            lazyLoad: 'ondemand',

            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.initSlickSliders();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/sliders.js